"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
var utilities_1 = require("@fluentui/utilities");
var Slider_base_1 = require("./Slider.base");
var Slider_styles_1 = require("./Slider.styles");
exports.Slider = (0, utilities_1.styled)(Slider_base_1.SliderBase, Slider_styles_1.getStyles, undefined, {
    scope: 'Slider',
});
//# sourceMappingURL=Slider.js.map